<template>
  <CommonModal>
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <draggable v-model="form.exhaustCertiList">
        <div v-for="item in form.exhaustCertiList" :key="item.exhaustCertiId" class="order-box">
          {{ item.exhaustCertiName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import {getExhaustCertiList, updateExCertiOrder} from "@/api/exhaustcerti";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        exhaustCertiList: [],
      },
    };
  },
  methods: {
    async fetchData(lang){
      try {
        const response = await getExhaustCertiList(lang);
        this.form.exhaustCertiList = response.data.list;
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.exhaustCertiList.forEach(function (item, index) {
        item.exhaustCertiSort = index;
      });
      await updateExCertiOrder(this.form);
    },
  }
}
</script>

<style>
</style>